import React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import styles from '../../styles/wizards/LinkExistingFilesWizard.scss';
import { __ } from '../../core/utils';
import FolderClosedIcon from '../../assets/images/folder-closed-16x16.svg';
import ArrowDownIcon from '../../assets/images/arrow-down-middle-15x15.svg';

const UNALLOCATED = 'unallocated';

const FolderTree = ({
  folders,
  expandedFolderIds,
  activeFolderId,
  allFilesTotal,
  unallocatedCount,
  onSelectAll,
  onSelectFolder,
  onSelectUnallocated,
  onToggleFolder,
}) => {
  const renderFolders = (items, level = 0) =>
    _.map(items, (folder) => {
      const hasChildren = !_.isEmpty(folder.children);
      const expanded = _.includes(expandedFolderIds, folder.id);

      return (
        <React.Fragment key={folder.id}>
          <div
            className={classNames(
              styles.folder,
              Number(activeFolderId) === Number(folder.id) && styles.active,
            )}
            style={{ paddingLeft: 14 + level * 22 }}
            onClick={() => onSelectFolder(folder)}
          >
            <span
              className={classNames(
                styles.folderArrow,
                expanded && styles.expanded,
                !hasChildren && styles.hidden,
              )}
              onClick={(event) => {
                event.stopPropagation();

                if (hasChildren) {
                  onToggleFolder(folder.id);
                }
              }}
            >
              <ArrowDownIcon />
            </span>
            <FolderClosedIcon
              className={styles.folderIcon}
              style={folder.color_hex ? { color: folder.color_hex } : undefined}
            />
            <span className={styles.folderTitle}>{folder.title}</span>
            <span className={styles.folderCount}>{folder.count}</span>
          </div>
          {hasChildren && expanded &&
            renderFolders(folder.children, level + 1)}
        </React.Fragment>
      );
    });

  return (
    <div className={styles.folders}>
      <div className={styles.sectionTitle}>
        {__('files.wizard.project-files', {}, 'Project files')}
      </div>
      <div
        className={classNames(
          styles.folder,
          _.isNil(activeFolderId) && styles.active,
        )}
        onClick={onSelectAll}
      >
        <span className={classNames(styles.folderArrow, styles.hidden)} />
        <FolderClosedIcon className={styles.folderIcon} />
        <span className={styles.folderTitle}>
          {__('files.wizard.all-files', {}, 'All files')}
        </span>
        <span className={styles.folderCount}>{allFilesTotal}</span>
      </div>
      {renderFolders(folders)}
      <div
        className={classNames(
          styles.folder,
          activeFolderId === UNALLOCATED && styles.active,
        )}
        onClick={onSelectUnallocated}
      >
        <span className={classNames(styles.folderArrow, styles.hidden)} />
        <FolderClosedIcon className={styles.folderIcon} />
        <span className={styles.folderTitle}>{__('Unallocated')}</span>
        <span className={styles.folderCount}>{unallocatedCount}</span>
      </div>
    </div>
  );
};

export default FolderTree;
